/* unplugin-vue-components disabled */import script from "./ClinicUser.vue?vue&type=script&setup=true&lang=js"
export * from "./ClinicUser.vue?vue&type=script&setup=true&lang=js"

import "./ClinicUser.vue?vue&type=style&index=0&id=815f707c&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-815f707c"]])

export default __exports__